export default "__VITE_ASSET__BWhQJIQS__"